module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("No permissions ,对不起，您没有权限访问该页面")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3c4bfe6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/403.vue
// module id = 681
// module chunks = 1